import * as TierGroups from 'marketplace-ui-common/constants/groupTags/TierGroups';
const orderedTierArrays = [TierGroups.CRM, TierGroups.MARKETING, TierGroups.SALES, TierGroups.SERVICE, TierGroups.CONTENT, TierGroups.OPERATIONS];
const flattenedTierOrder = orderedTierArrays.flat();
function getLowestTier(tiers) {
  return tiers.sort((tierA, tierB) => flattenedTierOrder.indexOf(tierA) - flattenedTierOrder.indexOf(tierB))[0];
}
function getHasMultipleHubOptions(tiers) {
  return orderedTierArrays.filter(hubTiers => {
    return hubTiers.some(tier => tiers.includes(tier));
  }).length > 1;
}
function getTierArray(scopeKey, featureCompatibility) {
  var _featureCompatibility, _featureCompatibility2;
  return (featureCompatibility === null || featureCompatibility === void 0 || (_featureCompatibility = featureCompatibility.compatibleTiers) === null || _featureCompatibility === void 0 ? void 0 : _featureCompatibility.tiersCompatibleWithScopeGroup[scopeKey]) || (featureCompatibility === null || featureCompatibility === void 0 || (_featureCompatibility2 = featureCompatibility.compatibleTiers) === null || _featureCompatibility2 === void 0 ? void 0 : _featureCompatibility2.tiersCompatibleWithScope[scopeKey]) || [];
}
export function getTierIntersectionForFeature(feature, featureCompatibility) {
  if (!featureCompatibility) return [];
  const {
    scopeGroups,
    internal: {
      scopes
    }
  } = feature;
  const leastPermissiveTierArray = [...scopeGroups, ...scopes].reduce((shortestTierArr, scopeKey) => {
    const currentTierArr = getTierArray(scopeKey, featureCompatibility);
    if (!shortestTierArr.length && currentTierArr.length) {
      return currentTierArr;
    } else {
      return currentTierArr.length && currentTierArr.length < shortestTierArr.length ? currentTierArr : shortestTierArr;
    }
  }, []);
  const tierIntersection = leastPermissiveTierArray.filter(tier => {
    // filter out unexpected values
    if (!flattenedTierOrder.includes(tier)) {
      return false;
    }
    // filter out any tier that isn't in the tierArr for all other scopeGroups and scopes
    [...scopeGroups, ...scopes].forEach(scopeKey => {
      const tierArr = getTierArray(scopeKey, featureCompatibility);
      if (!tierArr.includes(tier)) {
        return false;
      }
    });
    return true;
  });
  return tierIntersection;
}
export function getMissingCompatibilityRequirements(features, installability, checkForMultipleHubOptions = false) {
  if (!features || !installability) {
    return [];
  }
  const {
    featureCompatibilities,
    portalTiers
  } = installability;
  const missingCompatibilityRequirements = features.map(feature => {
    const featureCompatibility = featureCompatibilities === null || featureCompatibilities === void 0 ? void 0 : featureCompatibilities.find(compat => compat.featureId === feature.id);
    const tierIntersection = getTierIntersectionForFeature(feature, featureCompatibility);
    if (!(portalTiers !== null && portalTiers !== void 0 && portalTiers.filter(tier => tierIntersection.includes(tier)).length)) {
      // if none of the portalTiers overlap with the tierIntersection of all scopeGroups and scopes,
      // return the lowest compatible tier from tierIntersection to display below the feature.
      // This covers the case where a portal is missing a conditionally required scope
      // since that is covered by the tier intersection logic.

      const hasMultipleHubOptions = getHasMultipleHubOptions(tierIntersection);
      if (checkForMultipleHubOptions && hasMultipleHubOptions) {
        return 'MULTIPLE_HUB_OPTIONS_AVAILABLE'; // COMPATIBILITY_NONE
      } else {
        return getLowestTier(tierIntersection); // COMPATIBILITY_NONE
      }
    }
    if (featureCompatibility !== null && featureCompatibility !== void 0 && featureCompatibility.missingConditionallyRequiredPortalUserScopes.length) {
      // if the user is missing a conditionally required scope, flag this so that
      // partial compatibility messaging will be displayed on the feature

      return 'USER_CONDITIONAL_SCOPE'; // COMPATIBILITY_SOME
    }

    // if any portalTiers overlap with the tierIntersection of all scopeGroups and scopes,
    // and no conditional scopes are flagged as missing,
    // portal and user are compatible with the feature

    return ''; // COMPATIBILITY_ALL
  });
  return missingCompatibilityRequirements;
}